/*
https://splidejs.com/guides/getting-started/
*/
import Splide from '@splidejs/splide';

const slider = document.querySelector('.home-face .procedures-slider');

if( slider ) {
    var splide = new Splide(slider, {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: true,
        perPage: 2,
        perMove: 1,
        padding: {
            right: '10%'
        },
        gap: '1%',
        breakpoints: {
            768: {
                perPage: 2,
                padding: {
                    right: '7%'
                },
            },
        }
    });
    splide.mount();
}
